import React, { useCallback, useEffect, useRef } from 'react';
import { BottomSheet, IconClose, Stack, Text } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
const InfoBottomSheetModal = ({ isOpen, setIsOpen }) => {
    const ref = useRef(null);
    const handleClose = useCallback(() => {
        setIsOpen(false);
        ref.current?.dismiss();
    }, [setIsOpen]);
    useEffect(() => {
        if (isOpen) {
            ref.current?.present();
        }
        else {
            ref.current?.dismiss();
        }
    }, [isOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement(BottomSheet, { ref: ref, enableDynamicSizing: true, topNavigationProps: {
                title: i18n.t('CreateAccountAccountInfo.modals.addMobileNumber.title'),
                buttonStart: {
                    element: React.createElement(IconClose, null),
                    onPress: handleClose,
                    label: i18n.t('Global.microcopy.common.cancel'),
                },
            }, onBackdropClick: handleClose, onDismiss: handleClose, testID: "MobileNumberInfoBottomSheetModal" },
            React.createElement(Stack, { flexDirection: "column", gap: "$4", marginBottom: "$4" },
                React.createElement(Text, { testID: "CreateAccountAccountInfo.modals.addMobileNumber.body", nativeID: "CreateAccountAccountInfo.modals.addMobileNumber.body" }, i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.helpText.verifyAccountModal'))))));
};
export default InfoBottomSheetModal;
